<script setup>
import GenericInputGroup from '@/components/ui/input-group/GenericInputGroup.vue'
import { usePlaceholders } from '@/composables';
import { computed } from 'vue';
import { cn } from '@/lib/utils';

const {phoneNumberPlaceholder} = usePlaceholders()

const props = defineProps({
    modelValue: { type: [String, Number], required: false },
    placeholder: { type: String, required: false },
    type: { type: String, required: false, default: 'text' },
    errorMessages: { type: Array, default: () => [] },
    countryName: { type: String, required: true },
    countryCode: { type: String, required: true },
    countryFlag: { type: String, required: true },
    class: { type: String, required: false },
})

const emit = defineEmits(['update:modelValue'])

const model = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
})

const computedPlaceholder = computed(() => {
    return props.placeholder 
        ? props.placeholder
        : phoneNumberPlaceholder.value
})
</script>

<template>
  <GenericInputGroup
    v-model="model"
    :placeholder="computedPlaceholder"
    :type="type"
    :error-messages="errorMessages"
    :class="cn('bg-white placeholder:text-text-soft', props.class)"
  >
    <template #prepend>
        <div class="flex justify-start items-center space-x-2 w-full pr-2">
            <img
                :src="countryFlag"
                :alt="countryName"
                class="w-6 h-6 rounded-full block"
            />
            <span
                class="text-sm w-full font-medium"
            >
                {{ countryCode }}
            </span>
        </div>
    </template>
  </GenericInputGroup>
</template>
